import { ChevronRight, TipsAndUpdatesOutlined } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { BodyText } from '@/components/BodyText';
import { DashboardTile } from './DashboardTile';
import { RecommendationCard } from './useRecommendations';

const CardGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '12px',
});

const Card = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
}));

const CallToActionLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginTop: 'auto',
  paddingTop: '8px',
  fontSize: '0.875rem',
  fontWeight: 600,
  textDecoration: 'none',
  color: theme.palette.secondary.main,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const RecommendationTile = ({ recommendations }: { recommendations: RecommendationCard[] }) => (
  <DashboardTile id='recommendations' title='Recommended for you' icon={<TipsAndUpdatesOutlined />}>
    <CardGrid>
      {recommendations.map(({ id, title, pitch, callToAction }) => (
        <Card key={id} data-testid={`recommendation-${id}`}>
          <BodyText fontWeight={600}>{title}</BodyText>
          <BodyText color='text.secondary'>{pitch}</BodyText>
          <CallToActionLink to={callToAction.to}>
            {callToAction.label}
            <ChevronRight fontSize='small' />
          </CallToActionLink>
        </Card>
      ))}
    </CardGrid>
  </DashboardTile>
);
